"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockMitekDecision = void 0;
const mitekMockService_1 = require("./domain/mitekMockService");
const mockMitekDecision = (API, progressId) => {
    const mockDecision = async (decision) => {
        const res = await mitekMockService_1.mitekMockService.fetchMitekMock({ API, decision, progressId });
        return res.decision;
    };
    return {
        mockDecision,
    };
};
exports.mockMitekDecision = mockMitekDecision;
exports.default = exports.mockMitekDecision;
//# sourceMappingURL=mockMitekDecision.js.map